
        var result = require("!!../../../../node_modules/css-loader/index.js!./supplier.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-base/supplier.component.css
// module id = 2409
// module chunks = 1